import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {useLayout} from '../../core'
import {WelcomeLogo, MobileLogo} from '../ThemeAwareLogo'
import clsx from 'clsx'

export const WelcomeHeader: FC = () => {
  const {config, classes, attributes} = useLayout()
  const {header, aside} = config

  // Disable aside
  aside.display = false

  header.left = 'page-title'

  return (
    <div
      id='kt_header'
      className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
      {...attributes.headerMenu}
    >
      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-stretch justify-content-between'
        )}
      >
        {/* begin::Aside mobile toggle */}
        {aside.display && (
          <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
            <div
              className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
              id='kt_aside_mobile_toggle'
            >
              <i className='fas fa-bars fs-2 mt-1' />
            </div>
          </div>
        )}
        {/* end::Aside mobile toggle */}

        {/* begin::Logo */}
        {!aside.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
            <WelcomeLogo />
          </div>
        )}
        {/* end::Logo */}

        {aside.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
            <div className='d-lg-none'>
              <MobileLogo to='/' />
            </div>
          </div>
        )}

        {/* begin::Wrapper */}
        <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
          {/* begin::Navbar */}
          {header.left === 'page-title' && (
            <div className='d-flex align-items-center' id='kt_header_nav'>
              {/* Page title can be added here if needed */}
            </div>
          )}

          <div className='d-flex align-items-stretch flex-shrink-0'>
            {/* Login Button */}
            <div className='d-flex align-items-center me-3'>
              <Link to='/signin' className='btn btn-bioabm'>
                Login
              </Link>
            </div>
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
    </div>
  )
}
